// extracted by mini-css-extract-plugin
module.exports = {"comp":"CardInfoBtn_comp__3bipD","ef-box":"CardInfoBtn_ef-box__Cq5cQ"};